import axios from 'axios';

const API_BASE_URL = 'https://49pgt66j8g.execute-api.us-west-2.amazonaws.com/prod';
const TENANT_API_URL = process.env.REACT_APP_TENANT_API || 'https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod';
const CUR_API_URL = `${TENANT_API_URL}/v2/finops/cur`;

export const getTenantData = async (tenantId) => {
  const response = await axios.get(`${API_BASE_URL}/customer/${tenantId}`);
  const data = response.data;
  const cloudAccounts = typeof data.cloudAccounts === 'string' ? JSON.parse(data.cloudAccounts) : data.cloudAccounts;
  
  return {
    tenantId,
    companyName: data.companyName || 'Unknown',
    organizations: (cloudAccounts?.organizations || []).map(org => ({
      orgId: org.orgId,
      managementAccountId: org.id,
      accounts: [
        { accountId: org.id, accountName: 'Management', connected: true, isManagement: true },
        ...(org.memberAccounts || []).map(acc => ({
          accountId: acc.accountId,
          accountName: acc.accountName,
          connected: acc.connected || false,
          isManagement: false
        }))
      ]
    }))
  };
};

export const getTenantCosts = async (tenantId) => {
  const { organizations } = await getTenantData(tenantId);
  if (organizations.length === 0) return { totalCost: 0, organizations: [] };
  
  const orgCosts = await Promise.all(
    organizations.map(org => getOrganizationCosts(tenantId, org.orgId))
  );
  
  return {
    totalCost: orgCosts.reduce((sum, org) => sum + org.totalCost, 0),
    organizations: orgCosts
  };
};

export const getOrganizationCosts = async (tenantId, orgId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/finops/organization-costs`, {
      tenant_id: tenantId,
      organization_id: orgId,
      period: 'MTD'
    });
    return {
      orgId,
      totalCost: response.data.totalCost || 0,
      accounts: response.data.accounts || []
    };
  } catch (error) {
    return { orgId, totalCost: 0, accounts: [] };
  }
};

export const getCURMetrics = async (tenantId, period = null) => {
  try {
    // Get SP coverage as the main metric
    const spData = await executeCURQuery(tenantId, 'sp_coverage');
    if (!spData || !spData.coverage_by_service) return null;
    
    // Aggregate across all services
    const totalCovered = spData.coverage_by_service.reduce((sum, s) => sum + (s.sp_covered || 0), 0);
    const totalOnDemand = spData.coverage_by_service.reduce((sum, s) => sum + (s.on_demand || 0), 0);
    const totalSavings = spData.coverage_by_service.reduce((sum, s) => sum + (s.savings_realized || 0), 0);
    const totalCost = totalCovered + totalOnDemand;
    const coveragePct = totalCost > 0 ? (totalCovered / totalCost * 100) : 0;
    
    return {
      sp_summary: {
        coverage_pct: coveragePct,
        sp_covered: totalCovered,
        on_demand: totalOnDemand,
        savings_realized: totalSavings
      },
      waste_summary: {
        total_waste_cost: 0,
        unused_resource_count: 0
      }
    };
  } catch (error) {
    console.error('CUR metrics not available:', error);
    return null;
  }
};

export const executeCURQuery = async (tenantId, queryType, params = {}) => {
  try {
    const response = await axios.post(`${CUR_API_URL}/query`, {
      tenant_id: tenantId,
      query_type: queryType,
      ...params
    });
    return response.data;
  } catch (error) {
    console.error(`CUR query ${queryType} failed:`, error);
    return null;
  }
};
